import { useSelector } from 'react-redux';

import { Deployments } from './Deployments';
import { HistoryDeploymentRoutes } from './HistoryDeployment';

import i18n from '~/common/helpers/i18n';
import { ConfirmDialogProvider } from '~/components/ConfirmDialogV2/contexts/confirmDialogProvider';
import Operation from '~/scenes/Others/scenes/App/Operation';

export const RoutesRun = () => {
  const environment = useSelector<any, any>(
    state => state.application.environment
  );
  const environments = useSelector<any, any>(
    state => state.application.environments?.allNames
  );

  const newEnvironment =
    environments && environments.length > 0
      ? environments.find((env: string) => env === environment) ||
        environments[0]
      : 'test';

  const routes = [
    {
      path: ':environment',
      name: 'run',
      title: i18n.t('label.run_tab'),
      element: (
        <ConfirmDialogProvider>
          <Deployments />
        </ConfirmDialogProvider>
      )
    },
    HistoryDeploymentRoutes
  ];

  return [
    {
      path: '/:realm/operation/run',
      element: (
        <Operation
          links={[
            {
              routeName: 'run',
              'data-testid': 'run-header-pipelines-tab',
              path: `operation/run/${newEnvironment}`,
              name: i18n.t(
                'scenes.beta.labels.upper_and_capitalize.capitalized',
                {
                  item: `${i18n.t('action.pipelines')}`
                }
              )
            },
            {
              roles: [`DEPLOYMENT:READ`],
              'data-testid': 'run-header-history-tab',
              routeName: 'run-history',
              path: 'operation/run/deployment/history',
              name: i18n.t(
                'scenes.beta.labels.upper_and_capitalize.capitalized',
                {
                  item: `${i18n.t('action.history')}`
                }
              )
            }
          ]}
          environmentSelectRouteWhiteList={['run']}
        />
      ),
      children: routes
    }
  ];
};
